import React from 'react';
import PropTypes from 'prop-types';
import {Message} from 'epic-diesel-common';
import {getMessage} from '../../common/Message';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';
import styles from './ContentAndInterestsSection.pcss';
import signupStyles from '../../../pages/signup/SignUp.pcss';

const validContent = [
    'LIVE_STREAMING',
    'GAMEPLAY_VIDEOS',
    'COSPLAY',
    'CINEMATIC_VIDEOS',
    'WEB_DEVELOPMENT',
    'FAN_ART',
    'MUSIC',
    'WRITTEN_CONTENT'
];

const validInterests = [
    'CONTENT_CREATION_CONTESTS',
    'ONLINE_EVENT',
    'LOCAL_EVENT',
    'REGIONAL_EVENT'
];

export default class ContentAndInterestsSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        content: PropTypes.array,
        interests: PropTypes.array,
        showContentError: PropTypes.bool,
        updateContent: PropTypes.func,
        updateInterests: PropTypes.func
    };

    render() {
        const {messages, content, updateContent, interests, updateInterests} = this.props;

        const contentEntries = validContent.map((item, key) => (
            <div className={styles.checkboxItem} key={`content-${key}`}>
                <CheckBox
                    name={item}
                    key={item}
                    validationError={getMessage(messages, 'ui.form.agreement.required')}
                    value={content.includes(item)}
                    onChange={updateContent}>
                    <Message code={`epic.affiliate.signup.content.values.${item}`} />
                </CheckBox>
            </div>
        ));

        const interestsEntries = validInterests.map((item, key) => (
            <div className={styles.checkboxItem} key={`interests-${key}`}>
                <CheckBox
                    name={item}
                    key={item}
                    validationError={getMessage(messages, 'ui.form.agreement.required')}
                    value={interests.includes(item)}
                    onChange={updateInterests}>
                    <Message code={`epic.affiliate.signup.interests.values.${item}`} />
                </CheckBox>
            </div>
        ));

        return (
            <div className={signupStyles.header}>
                <h2>
                    <Message code="epic.affiliate.signup.content.header" />
                    {' *'}
                </h2>
                <p>
                    <Message code="epic.affiliate.signup.content.text" />
                </p>
                <div className={styles.contentEntries}>
                    {contentEntries}
                    {this.props.showContentError && (
                        <span className={styles.error}>
                            {' '}
                            <Message code="ui.form.content.required" />
                        </span>
                    )}
                </div>

                <h2>
                    <Message code="epic.affiliate.signup.interests.header" />
                </h2>
                <p>
                    <Message code="epic.affiliate.signup.interests.text" />
                </p>
                <div className={styles.contentEntries}>{interestsEntries}</div>
            </div>
        );
    }
}
